import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ArrowRightIcon, CheckCircleIcon, MapPinIcon } from '@heroicons/react/24/outline';

const PHOTO_DIR = `${process.env.PUBLIC_URL}/assets/images/warehouse`;

const reveal = {
  initial: { opacity: 0, y: 24 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true },
};

const facts = [
  'Fast clearance (max 15 minutes)',
  'Loading onto the aircraft within 6 hours',
  'NFO (next flight out)',
];

// Homepage band for the Singapore flagship warehouse in the Changi Airport FTZ.
const WarehouseSpotlight: React.FC = () => {
  return (
    <section id="warehouse" className="relative overflow-hidden py-14 lg:py-20">
      <div className="container-custom relative grid gap-10 lg:grid-cols-[1.15fr_0.85fr] lg:items-center">
        <motion.div {...reveal} transition={{ duration: 0.75 }} className="grid grid-cols-3 gap-3 sm:gap-4">
          <div className="relative col-span-3 overflow-hidden rounded-[28px] shadow-[0_28px_70px_-42px_rgba(15,23,42,0.6)]">
            <img
              src={`${PHOTO_DIR}/changi-ftz-airside.jpg`}
              alt="Inside the TrueLog flagship warehouse at Changi Airport, looking out to the airfield"
              loading="lazy"
              className="h-[240px] w-full object-cover sm:h-[340px]"
            />
          </div>
          {['changi-ftz-racking.jpg', 'changi-ftz-forklifts.jpg', 'changi-ftz-loading-bay.jpg'].map((file) => (
            <div key={file} className="overflow-hidden rounded-[20px] shadow-[0_20px_50px_-36px_rgba(15,23,42,0.5)]">
              <img src={`${PHOTO_DIR}/${file}`} alt="" loading="lazy" className="h-[140px] w-full object-cover sm:h-[200px]" />
            </div>
          ))}
        </motion.div>

        <motion.div {...reveal} transition={{ duration: 0.75, delay: 0.1 }}>
          <span className="eyebrow-pill">
            <MapPinIcon className="h-3.5 w-3.5" />
            Singapore Flagship Warehouse
          </span>
          <h2 className="mt-5 text-slate-950">Bonded storage in the Changi Airport Free Trade Zone.</h2>
          <p className="mt-5 text-base leading-8 text-slate-600 sm:text-lg">
            Our flagship warehouse sits inside the free trade zone at Changi Airport, minutes from the aircraft.
          </p>
          <ul className="mt-6 space-y-3">
            {facts.map((fact) => (
              <li key={fact} className="flex items-start gap-3 text-base leading-7 text-slate-700">
                <CheckCircleIcon className="mt-0.5 h-5 w-5 flex-shrink-0 text-[#0E9ED5]" />
                {fact}
              </li>
            ))}
          </ul>
          <p className="mt-6 text-sm leading-6 text-slate-500">
            7 Airline Road, #02-17 &amp; #02-18, Cargo Agents Building E, Singapore 819834
          </p>
          <Link
            to="/services/warehousing-fulfilment"
            className="mt-6 inline-flex items-center gap-2 text-sm font-semibold text-[#2447d8] transition-colors hover:text-[#0E9ED5]"
          >
            See warehousing &amp; fulfilment
            <ArrowRightIcon className="h-4 w-4" />
          </Link>
        </motion.div>
      </div>
    </section>
  );
};

export default WarehouseSpotlight;
